<template>
  <div class="menu-container">
    <div class="box" @click="toggleMenu">
      <img v-show="!isMenuOpen" src="@/assets/images/header/menu-open.png" alt="">
      <img v-show="isMenuOpen" src="@/assets/images/header/menu-close.png" alt="">
    </div>

    <!-- 主菜单快速下拉 -->
    <transition name="menu-mask-slide">
      <div v-show="isMenuOpen" class="menu-mask" @click.self="closeMenu">
        <div class="menu-panel">
          <div class="menu-list">
            <!-- 一级菜单 -->
            <div v-for="(item, index) in menusList" :key="`level1-${index}`" class="menu-item">
              <!-- 一级菜单：添加高亮竖条 -->
              <div class="menu-title" @click="handleItemClick(item)" :class="{ 'active': isCurrentMenu(item) }">
                {{ item.name }}
                <i v-if="item.children && item.children.length"
                  :class="!item.isExpanded ? 'el-icon-plus' : 'el-icon-minus'" class="submenu-icon"></i>
              </div>

              <!-- 二级菜单快速下拉 -->
              <transition name="sub-slide">
                <div v-show="item.isExpanded" class="submenu-list level2">
                  <div v-for="(subItem, subIndex) in item.children" :key="`level2-${subIndex}`"
                    class="submenu-item-wrap">
                    <!-- 二级菜单：添加高亮竖条 -->
                    <div class="submenu-item level2-item" @click="handleItemClick(subItem)"
                      :class="{ 'active': isCurrentMenu(subItem) }">
                      {{ subItem.name }}
                      <i v-if="subItem.children && subItem.children.length"
                        :class="!subItem.isExpanded ? 'el-icon-plus' : 'el-icon-minus'" class="submenu-icon"></i>
                    </div>

                    <!-- 三级菜单快速下拉 -->
                    <transition name="sub-slide">
                      <div v-show="subItem.isExpanded" class="submenu-list level3">
                        <div v-for="(thirdItem, thirdIndex) in subItem.children" :key="`level3-${thirdIndex}`"
                          class="submenu-item level3-item" @click="handleItemClick(thirdItem)"
                          :class="{ 'active': isCurrentMenu(thirdItem) }">
                          {{ thirdItem.name }}
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </transition>
            </div>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { menu } from "../../../constant/menu.js";
export default {
  name: "HeaderMenu",
  data() {
    return {
      isMenuOpen: false,
      menusList: [],
      currentRoute: '' // 记录当前路由
    };
  },

  created() {
    const new_menu = [...menu]
    new_menu.unshift({ name: '首页', route: '/' })
    this.menusList = this.initMenuData(new_menu);
    // 初始化当前路由
    this.currentRoute = this.getFullRoutePath(this.$route)
  },
  watch: {
    // 监听路由变化，更新当前选中状态
    '$route'(newRoute) {
      this.currentRoute = this.getFullRoutePath(newRoute)
    }
  },
  methods: {
    initMenuData(menuList) {
      return menuList.map(item => {
        const newItem = { ...item, isExpanded: false };
        if (item.children) newItem.children = this.initMenuData(item.children);
        return newItem;
      });
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        // 打开菜单时自动展开当前路由对应的菜单层级
        this.expandCurrentMenu(this.menusList);
      } else {
        this.resetAllMenuExpanded(this.menusList)
      }
    },
    resetAllMenuExpanded(menuList) {
      menuList.forEach(item => {
        item.isExpanded = false;
        if (item.children) this.resetAllMenuExpanded(item.children);
      });
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    handleItemClick(item) {
      if (item.children?.length) {
        item.isExpanded = !item.isExpanded;
      } else if (item.route) {
        this.closeMenu();
        this.$router.push(item.route);
        this.resetAllMenuExpanded(this.menusList)
      }
    },
    getFullRoutePath(route) {
      const { path, query } = route;
      if (!query || Object.keys(query).length === 0) {
        return path;
      }
      // 拼接 query 参数
      const queryString = Object.keys(query)
        .map(key => `${key}=${query[key]}`)
        .join('&');
      return `${path}?${queryString}`;
    },
    /**
     * 判断是否为当前选中的菜单
     */
    isCurrentMenu(menuItem) {
      // 匹配路由地址
      return menuItem.route === this.currentRoute;
    },
    /**
     * 递归展开当前路由对应的菜单层级
     */
    expandCurrentMenu(menuList) {
      for (let item of menuList) {
        // 如果是当前菜单，展开父级
        if (item.route === this.currentRoute) {
          return true;
        }
        // 递归检查子菜单
        if (item.children && this.expandCurrentMenu(item.children)) {
          item.isExpanded = true;
          return true;
        }
      }
      return false;
    }
  },
};
</script>

<style scoped lang="less">
.menu-container {
  position: relative;
  color: #fff;
}

.box {
  cursor: pointer;
  display: inline-block;

  img {
    width: 24px;
    height: 24px;
    display: block;
  }
}

.menu-mask {
  position: fixed;
  // 74px
  top: 71px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100vw !important;
  // 74px
  height: calc(100vh - 71px) !important;
  background: transparent !important;
  /* 去掉遮罩半透明 */
  pointer-events: none;
}

.menu-panel {
  width: 100%;
  height: 100%;
  background-color: #000;
  overflow-y: auto;
  padding: 20px 0;
  box-sizing: border-box;
  pointer-events: auto;
}

.menu-list {
  .menu-item {
    border-bottom: 1px solid #333;

    // 一级菜单样式 + 高亮竖条
    .menu-title {
      padding: 15px 20px;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      color: #fff;
      position: relative; // 相对定位，用于高亮条的绝对定位

      &:hover {
        background: #222;
      }

      .submenu-icon {
        color: #999;
      }

      // 高亮样式：左侧5px黄色竖条，高度拉满
      &.active {
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 3px;
          background-color: #ffd700; // 金黄色
        }

        // 高亮时文字颜色加深/变白
        color: #fff;
        background-color: #1a1a1a;
      }
    }

    .submenu-list.level2 {
      .submenu-item-wrap {
        width: 100%;
      }

      // 二级菜单样式 + 高亮竖条
      .submenu-item.level2-item {
        padding: 12px 20px 12px 30px;
        font-size: 14px;
        color: #ccc;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        position: relative; // 相对定位

        &:hover {
          background: #222;
        }

        // 高亮样式：左侧5px黄色竖条
        &.active {
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 5px;
            background-color: #ffd700;
          }

          color: #fff;
          background-color: #1a1a1a;
        }
      }

      .submenu-list.level3 {

        // 三级菜单样式 + 高亮竖条
        .submenu-item.level3-item {
          padding: 10px 20px 10px 40px;
          font-size: 13px;
          color: #999;
          cursor: pointer;
          position: relative; // 相对定位

          &:hover {
            background: #222;
            color: #fff;
          }

          // 高亮样式：左侧5px黄色竖条
          &.active {
            &::before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              height: 100%;
              width: 5px;
              background-color: #ffd700;
            }

            color: #fff;
            background-color: #1a1a1a;
          }
        }
      }
    }
  }
}


// ======================
// 新增：menu-mask 下拉动画
// ======================
.menu-mask-slide-enter-active,
.menu-mask-slide-leave-active {
  transition: transform 0.2s ease-out, opacity 0.15s ease-out;
}
// 进入时：从上方-10px位置滑下 + 轻微淡入
.menu-mask-slide-enter {
  transform: translateY(-10px);
  opacity: 0;
}
// 离开时：滑回上方 + 淡出
.menu-mask-slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

// ======================
// 子菜单：下拉展开
// ======================
.sub-slide-enter-active,
.sub-slide-leave-active {
  transition: max-height 0.25s linear;
  overflow: hidden;
}

.sub-slide-enter {
  max-height: 0;
}

.sub-slide-enter-to {
  max-height: 800px;
}

.sub-slide-leave {
  max-height: 800px;
}

.sub-slide-leave-to {
  max-height: 0;
}

</style>